import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as _ from 'lodash';

import { OccupationModel } from '@app/ps/models/occupation.model';
import { OccupationTypeModel } from '@app/ps/models/occupation-type.model';
import { ListModel } from '@app/common/models/list.model';
import { SettingsService } from '@app/ps/services/settings.service';
import { AuthService } from '@app/common/services/auth.service';
import { ArrayUtils } from '@app/common/utils/array.utils';
import { FinalSolutionStateEnum } from '@app/ps/enums/final-solution-state.enum';
import { ProjectTypesEnum } from "@app/ps/enums/project-types.enum";

@Component({
  selector: 'table-occupations',
  templateUrl: './table-occupations.component.html',
  styleUrls: ['./table-occupations.component.scss']
})
export class TableOccupationsComponent implements OnInit {
  @Input() list: ListModel<OccupationModel>;
  @Input() isChecked: Function;
  @Input() inverseSelection: boolean;
  @Output() checkAll: EventEmitter<any> = new EventEmitter();
  @Output() sort: EventEmitter<{}> = new EventEmitter();
  @Output() toggleCheckItem: EventEmitter<OccupationModel> = new EventEmitter();

  occupationTypesPermanent: OccupationTypeModel[] = [];
  occupationTypesTemporary: OccupationTypeModel[] = [];
  readonly FinalSolutionStateEnum = FinalSolutionStateEnum;
  rowspan: number;
  permanentOccupationRowspan: number;
  temporaryOccupationRowspan: number;
  defaultState: string;
  private readonly STATE_MAP = {
    [ProjectTypesEnum.INVEST]: 'Stav ZE',
    [ProjectTypesEnum.ADDITIONAL]: 'Stav EMH'
  };

  constructor(
    private settingsService: SettingsService,
    private authService: AuthService,
  ) {}

  ngOnInit() {
    const occupationTypes = JSON.parse(JSON.stringify(this.authService.getActualProject().occupationTypes));
    const projectType = this.authService.getActualProject().type;
    this.defaultState = this.STATE_MAP[projectType] || '';

    this.occupationTypesPermanent = _.filter(occupationTypes, (ot: OccupationTypeModel) =>
      ['permanent'].includes(ot.category)
    );
    this.occupationTypesTemporary = _.filter(occupationTypes, (ot: OccupationTypeModel) =>
      ['underOneYear', 'overOneYear'].includes(ot.category)
    );

    this.removeCommonStringFromTableHeading(this.occupationTypesPermanent, 'trvalý zábor');
    this.removeCommonStringFromTableHeading(this.occupationTypesTemporary, 'dočasný zábor');

    if (this.occupationTypesTemporary.length) {
      this.occupationTypesTemporary.push({ name: 'Délka nájmu (měsíc)', id: -1, number: undefined, category: 'rental_length' });
    }

    this.rowspan = this.shouldHaveSecondRow() ? 2 : 1;
    this.permanentOccupationRowspan = (this.shouldHaveSecondRow() && this.shouldDrawSecondRowOf(this.occupationTypesPermanent) ? 1 : 2);
    this.temporaryOccupationRowspan = (this.shouldHaveSecondRow() && this.shouldDrawSecondRowOf(this.occupationTypesTemporary) ? 1 : 2);
  }

  onCheckAll() {
    this.checkAll.emit();
  }

  onToggleCheckItem(occupation: OccupationModel) {
    this.toggleCheckItem.emit(occupation);
  }

  onSort(column: string, ascOrDesc: string) {
    this.sort.emit({ column, ascOrDesc });
  }

  hideColumn(columnId: string) {
    return this.settingsService.shouldHideColumn('occupations', columnId);
  }

  shouldDrawSecondRowOf(what: OccupationTypeModel[]): boolean {
    return !(what.length === 1 && what[0].name === '');
  }

  shouldHaveSecondRow(): boolean {
    const temp = [...this.occupationTypesPermanent, ...this.occupationTypesTemporary];
    return temp.filter((item) => item.name).length > 0;
  }

  private removeCommonStringFromTableHeading(heading: OccupationTypeModel[], commonString: string) {
    const headingNames = _.concat(_.map(heading, 'name'), commonString);
    const replaceFn = (str) => str.toLowerCase().replace(ArrayUtils.getLongestCommonSubstring(headingNames, true), '').trim();
    const wouldBeEmpty = heading.some((cur) => replaceFn(cur.name) === '');

    if (wouldBeEmpty && heading.length > 1) {
      return;
    }

    _.forEach(heading, (obj) => {
      obj.name = replaceFn(obj.name);
    });
  }
}
